import { FileDto } from '@tallo/file-manager';
import { RenterDto } from '@tallo/renter';

import { ApplicationBackgroundCheckStatus } from '../enums/application-background-check-status.enum';
import { ApplicationStatus } from '../enums/application-status.enum';
import { ApplicationReferenceDto } from './application-reference.interface';
import { ApplicationEmploymentInfoDto } from './employment.interface';
import { ApplicationRenterDetailsDto } from './renter-details.interface';
import { ApplicationResidenceInfoDto } from './residence-info.interface';

export interface ApplicationDto {
  id: string;
  type: ApplicantType;
  status: ApplicationStatus;
  backgroundCheckStatus: ApplicationBackgroundCheckStatus;
  screeningRequestRenterId: string;
  expiresAt: string;
  isPaid: boolean;
  renterDetails: ApplicationRenterDetailsDto | null;
  employmentInfo: ApplicationEmploymentInfoDto[];
  references: ApplicationReferenceDto[];
  residenceInfo: ApplicationResidenceInfoDto[];
  photoIds: FileDto[];
  petPhotos: FileDto[];
  additionalDocuments: FileDto[];
  proofsOfIncome: FileDto[];
  createdAt: string;
  updatedAt: string;
}

export enum ApplicantType {
  APPLICANT = 'Applicant',
  CO_APPLICANT = 'Co-Applicant',
  CO_SIGNER = 'Co-Signer',
}

export interface ApplicationWithRenterDto extends ApplicationDto {
  renter: RenterDto;
}
